import * as S from "./styles";
import { useLocation } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import selectedImage from "~/assets/png/promotion-modal.png";
import checkSuccessIcon from "~/assets/svg/check-success.svg";
import Modal from "~/components/ui/Modal";
import { SVG } from "~/components/ui/SVG";
import { faArrowRight } from "@fortawesome/pro-light-svg-icons";

const alidropLink =
  "https://app.alidrop.co/register?utm_source=dropshiptool&utm_medium=promotion";

function useIsMobile(breakpoint = 908) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < breakpoint : false
  );

  useEffect(() => {
    function onResize() {
      setIsMobile(window.innerWidth < breakpoint);
    }
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [breakpoint]);

  return isMobile;
}

export function AliDropPromotionModal() {
  const isMobile = useIsMobile(908);
  const location = useLocation();
  const [isShowing, setIsShowing] = useState(true);

  const shouldShowByQuery = useMemo(() => {
    const queryParams = new URLSearchParams(location.search);
    const planId = queryParams.get("plan_id") || "";
    const redirectStatus = queryParams.get("redirect_status") || "";
    const paymentIntentSecret =
      queryParams.get("payment_intent_client_secret") || "";
    const setupIntentSecret =
      queryParams.get("setup_intent_client_secret") || "";

    if (planId !== "") return true;

    // Stripe can return users without plan_id but with successful intent params.
    return (
      redirectStatus === "succeeded" &&
      (paymentIntentSecret !== "" || setupIntentSecret !== "")
    );
  }, [location.search]);

  const dismiss = () => setIsShowing(false);

  return (
    <Modal
      id="alidrop-promotion-funnel"
      minWidth={isMobile ? "90%" : "904px"}
      maxWidth={isMobile ? "" : "912px"}
      maxHeight={isMobile ? "" : "550px"}
      isShowing={isShowing && shouldShowByQuery}
      padding="0"
      closeOnBackdropClick={false}
      scrollable="hidden">
      <S.ModalContainer>
        <S.ContentGrid isMobile={isMobile}>
          <S.ImageWrapper isMobile={isMobile}>
            <S.Image
              src={selectedImage}
              isMobile={isMobile}
              alt="AliDrop Promotion"
            />
          </S.ImageWrapper>

          <div>
            <S.TextContent isMobile={isMobile}>
              <S.Heading>
                Find AliExpress <S.TextColor>Winning Products</S.TextColor>
              </S.Heading>

              <S.Subheading>
                Find AliExpress Winning products, along with top selections from
                Alibaba and Temu, and trusted US and EU suppliers.
              </S.Subheading>
              <S.FeatureList>
                <S.FeatureItem>
                  <img
                    src={checkSuccessIcon}
                    alt="Checkmark"
                    width={20}
                    height={20}
                  />
                  AliExpress Trending Products
                </S.FeatureItem>
                <S.FeatureItem>
                  <img
                    src={checkSuccessIcon}
                    alt="Checkmark"
                    width={20}
                    height={20}
                  />
                  Grow Profit with No Risk
                </S.FeatureItem>
              </S.FeatureList>

              <S.CtaButton
                isMobile={isMobile}
                type="button"
                onClick={() =>
                  window.open(alidropLink, "_blank", "noopener,noreferrer")
                }>
                Start Free Trial
              </S.CtaButton>
            </S.TextContent>
            <S.ButtonContainer>
              <S.ContinueButton
                isMobile={isMobile}
                type="button"
                onClick={dismiss}>
                Continue to dashboard
                <SVG icon={faArrowRight} size="sm" />
              </S.ContinueButton>
            </S.ButtonContainer>
          </div>
        </S.ContentGrid>
      </S.ModalContainer>
    </Modal>
  );
}
